import Logo from "../../../assets/images/club-car-connect-logo.png";
import React, { useContext, useState, useEffect, useRef } from "react";
import CustomizedButtons from "commonComponents/Button";
import CheckIcon from "assets/svgIcons/CheckIcon";
import { StyledCheckbox } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import {
  Container,
  PageTitle,
  InputBoxWrapper,
  Wrapper,
  ActionWrapper,
} from "../UserAuthStyled";
import { AuthContext } from "auth/Auth";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import Cookies from "universal-cookie";
import { t } from "i18next";

export const SignIn = () => {
  const cookies = new Cookies();
  const checkRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData: loginDataInfo } =
    useSelector((state) => state.commonReducers) || [];
  const [inputVal, setInputVal] = useState({
    uname: cookies.get("userName") || "",
    pass: cookies.get("userPass") || "",
  });

  const [msg, setMsg] = useState({
    usePass: false,
    use: false,
    Pass: false,
    incorrect: false,
  });

  const { handleLogin } = useContext(AuthContext);
  const handleInput = (e) => {
    setMsg({
      usePass: false,
      use: false,
      Pass: false,
      incorrect: false,
    });
    const { name, value } = e.target;
    setInputVal({
      ...inputVal,
      [name]: value,
    });
  };

  const rememberMe = () => {
    if (checkRef.current.checked) {
      setCookie();
    }
  };
  const login = (e) => {
    e.preventDefault();
    const { uname, pass } = inputVal;

    if (uname === "" && pass === "") {
      setMsg({ usePass: true });
    } else if (uname === "") {
      setMsg({ use: true });
    } else if (pass === "") {
      setMsg({ pass: true });
    }
    else if (uname !== "" && pass !== "") {
      dispatch(
        COMMON_SERVICES.getAuthUserInfoServices({
          password: pass,
          userName: uname,
        })
      ).then(() => {
        localStorage.setItem(
          "sideDrawerActiveTabState",
          0
        )
        localStorage.setItem("subNavState", "true");
        localStorage.setItem(
          "subNavDataState",
          "Dashboard"
        )
        setMsg({ incorrect: !loginDataInfo?.success });
      });
      rememberMe();
    }
  };

  useEffect(() => {
    if (loginDataInfo?.success && localStorage.getItem("vkey")) {
      handleLogin();
      if (window.innerWidth > 850) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/map", { replace: true });
      }
    } else {
      navigate("/", { replace: true });
    }
  }, [loginDataInfo]);

  const setCookie = () => {
    cookies.set("userName", inputVal.uname, { path: "http://localhost:3000/" });
    cookies.set("userPass", inputVal.pass, { path: "http://localhost:3000/" });
  };

  return (
    <Container>
      <img src={Logo} alt="logo" className="logo" />
      <Wrapper>
        <PageTitle>Sign in</PageTitle>
        <form onSubmit={login}>
          <InputBoxWrapper>
            <p>{t("Username")}</p>
            <input
              tabIndex="1"
              type="text"
              id="fname"
              placeholder="Enter your Username"
              name="uname"
              value={inputVal.uname}
              onChange={handleInput}
              autoComplete="off"
            />
            {msg.use && (
              <div className="error">The User name field is required</div>
            )}
            <span
              tabIndex="2"
              onClick={() => navigate("/ForgetUsername")}
              onKeyPress={(e) => {
                if (e.key === "Enter") navigate("/ForgetUsername");
              }}
              className="bottom-span"
            >
              Forgot Username?
            </span>
          </InputBoxWrapper>
          <InputBoxWrapper>
            <p>Password</p>
            <input
              tabIndex="3"
              type="password"
              id="lname"
              placeholder="Enter your password"
              name="pass"
              value={inputVal.pass}
              onChange={handleInput}
              autoComplete="off"
            />
            {msg.pass && (
              <div className="error">The Password field is required</div>
            )}
            <span
              tabIndex="4"
              onClick={() => navigate("/ForgetPassword")}
              onKeyPress={(e) => {
                if (e.key === "Enter") navigate("/ForgetPassword");
              }}
              className="bottom-span"
            >
              Forgot Password?
            </span>
          </InputBoxWrapper>

          <StyledCheckbox>
            <FormControlLabel
              inputRef={checkRef}
              control={
                <Checkbox
                  icon={<UnCheckIcon width={20} height={20} />}
                  checkedIcon={<CheckIcon width={20} height={20} />}
                />
              }
              label="Remember me"
            />
          </StyledCheckbox>
          <ActionWrapper>
            <CustomizedButtons type="submit" title="Sign In" />
            {msg.usePass && (
              <div className="error">
                User name and password fields are required
              </div>
            )}
            {msg.incorrect && (
              <div className="error">
                {" "}
                The user name or password provided are incorrect.
              </div>
            )}
          </ActionWrapper>
        </form>
      </Wrapper>
    </Container>
  );
};
